import React,{useMemo} from 'react';
import {useEditorFrame} from './useEditorFrame';
import {handwritingHtml} from './handwritingDocument';

export default function HandwritingNotebook({data,onChange,readOnly=false,preserveViewport=false}) {
    const options=useMemo(()=>({readOnly,preserveViewport}),[readOnly,preserveViewport]);
    const {iframeRef,onLoad}=useEditorFrame(data,readOnly?undefined:onChange,'handwriting',options);
    return <iframe ref={iframeRef} onLoad={onLoad} srcDoc={handwritingHtml} title="Handwriting Notebook" className="w-full h-full border rounded-lg" style={{minHeight:'400px'}}/>;
}
